import { extractData } from "../http/http.service";
import type { Denom } from "../types/denom.type";
import type { HttpClient } from "../utils/httpClient";

export interface RawBalance {
  amount: string;
  denom: Denom;
}

export interface Balance {
  amount: number;
  denom: Denom;
}

interface BalanceResponse {
  balance: RawBalance;
}

export class BalanceHttpService {
  constructor(private readonly httpClient: HttpClient) {}

  async getBalance(address: string, denom: string): Promise<Balance | undefined> {
    const response = extractData(await this.httpClient.get<BalanceResponse>(`cosmos/bank/v1beta1/balances/${address}/by_denom?denom=${denom}`));
    return response.balance ? { amount: parseFloat(response.balance.amount), denom: response.balance.denom } : undefined;
  }
}
